import { render, staticRenderFns } from "./OurTableFooter.vue?vue&type=template&id=48301190&"
import script from "./OurTableFooter.vue?vue&type=script&lang=js&"
export * from "./OurTableFooter.vue?vue&type=script&lang=js&"
import style0 from "./OurTableFooter.vue?vue&type=style&index=0&id=48301190&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports